// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"641":"0008acea","993":"fa4097ff"}[chunkId] + ".chunk.css";
};